module.exports = __webpack_public_path__ + "static/person-3-70x70-e60402e27d80f89bd62408fdd4c17839.png";